import React, { useEffect } from "react";
import Header from "./components/HeaderComponent/Header";
import Login from "./components/LoginComponent/Login";
import Menu from "./components/MenuComponent/Menu";
import "../src/assests/css/master.css";
import { Route, Routes, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/Errorboundry/Errorboundry";
import UpiHome from "./components/PayinHistory";

import FooterComponent from "./components/FooterComponent/FooterComponent";
import { ToastContainer } from "react-toastify";
import TicketDeatails from "./Ticket/TicketDeatails";
import TokenList from "./Ticket/Ticket";
import "react-tooltip/dist/react-tooltip.css";
import UserList from "./components/Userlist";
import HomePage from "./components/HomePage";
import PayoutHistory from "./Payout";
import AddNewClient from "./components/Adduser/AddNewClient";
import MerchantWallet from "./components/MerchantWalletHistory";
import Reporting from "./components/reporting";
import ForgetPassword from "./components/LoginComponent/ForgetPassword";
import MerchantProfile from "./components/profile/AddNewClient";
import OrderRequest from "./components/Adduser/OrderRequest";

const App = () => {
  useEffect(() => {
    // Dynamically set the document title based on environment
    const env = process.env.REACT_APP_ENV;
    if (env === "klikpay") {
      document.title = "KlikPay Merchant Portal";
    } else if (env === "paytom") {
      document.title = "Paytom Merchant Portal";
    } else if (env === "qrbonpay") {
      document.title = "QRBonPay Merchant Portal";
    } else if (env === "qa") {
      document.title = "QA Admin Portal";
    } else {
      document.title = "Admin Portal";
    }
  }, []);
  const PublicRoute = ({ children }) => {
    let token = sessionStorage.getItem("token");

    return token ? (
      <Navigate to="/dashboard" replace />
    ) : (
      <ErrorBoundary>{children}</ErrorBoundary>
    );
  };

  const PrivateRoute = ({ children }) => {
    let token = sessionStorage.getItem("token");

    return token ? (
      <React.Fragment>
        <Header />
        <Menu />
        <ErrorBoundary>{children}</ErrorBoundary>
        <ToastContainer />
      </React.Fragment>
    ) : (
      <Navigate to="/" replace />
    );
  };
  return (
    <React.Fragment>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <ForgetPassword />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/pay-in"
          element={
            <PrivateRoute>
              <UpiHome />
            </PrivateRoute>
          }
        />
        <Route
          path="/pay-out"
          element={
            <PrivateRoute>
              <PayoutHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-list"
          element={
            <PrivateRoute>
              <UserList />
            </PrivateRoute>
          }
        />
        <Route
          path="/merchant-wallet-ledger"
          element={
            <PrivateRoute>
              <MerchantWallet />
            </PrivateRoute>
          }
        />

        <Route
          path="/ticket"
          element={
            <PrivateRoute>
              <TokenList />
            </PrivateRoute>
          }
        />
        <Route
          path="/ticket-details"
          element={
            <PrivateRoute>
              <TicketDeatails />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-managment"
          element={
            <PrivateRoute>
              <AddNewClient />
            </PrivateRoute>
          }
        />
        <Route
          path="/report"
          element={
            <PrivateRoute>
              <Reporting />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <MerchantProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/order-request"
          element={
            <PrivateRoute>
              <OrderRequest />
            </PrivateRoute>
          }
        />
      </Routes>
      <FooterComponent />
    </React.Fragment>
  );
};

export default App;
